export interface IKeyFiguresLoan {
  description: string
  loanNr: string
  supplierFullName: string
  loanBalance: number
  loanAmount: number
  loanReason: string
  loanIndexNr: number
  logoUrl: string
}

export interface IKeyFiguresReports {
  id: string
  title: string
  periode: string
}

export interface IKeyFiguresAccounts {
  accountNr: string
  balance: number
  accountName: string
  logoUrl: string
  lastTransactionDate: string
}

export interface IKeyFiguresJointCost {
  date: number
  maturityDate: Date
  securityScheme: boolean
  transferFinanceCompany: boolean
  bblFinance: boolean
  balance: number
  debitorInvoiceType: string
  debitorInvoiceTypeText: string
}
export interface IKeyFiguresLiquidity {
  clientId: string
  status: number
  liqidityPrUnit: number
  liqidityTotal: number
  latestReportId: string
  latestReportPeriod: number
  latestReportTitle: string
  statusText: string
}

export interface IKeyFiguresCashflowAccount {
  accountName: string
  accountNr: string
  balance: number
  includeInLiquidityCalculations: boolean
  logoUrl: string
  remittance: boolean
}

export interface IKeyFiguresCashflow {
  accounts: IKeyFiguresCashflowAccount[]
  clientId: string
  status: number
  cashflowPrUnit: number
  cashflowTotal: number
  latestReportId: string
  latestReportPeriod: number
  latestReportTitle: string
  account: number
  invoice: number
  loan: number
  income: number
  statusText: string
  lastUpdated: Date
  calculationDate: Date
}

export enum LiquidityStatusEnum {
  Low = 1,
  Medium = 2,
  High = 3,
  NotSet = 4,
  NoUnits = 5,
  CriticallyLow = 6,
  VeryGood = 7,
}
export interface IKeyFiguresUnpaidInvoices {
  amount: number
  supplierFullName: string
  dueDate: string
  invoiceId: string
  key: number
}

export interface IOperatingCostKeyFiguresModel {
  periode: number
  balanceBudget: number
  balanceAccounts: number
  name: string
}

export interface IKeyFiguresResultsModel {
  period: number
  income: number
  cost: number
  accumulatedResult: number
  name: string
}

export enum ActiveChartEnum {
  OperatingCosts = 1,
  Results = 2,
}

export enum LiquidityPrPeriodEnum {
  LastMonth = 1,
  Today = 2,
}
